import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ProgressButton from "../generic/ProgressButton";
import Logo from "../../assets/logo.png";
import { auth } from "../../services/firebase";

const useStyles = makeStyles({
  paper: {
    padding: "2rem",
    width: "35rem",
    margin: "2rem auto",
    border: "2px solid #666",
  },
  avatar: {
    backgroundColor: "black",
  },
  logo: {
    height: "100%",
    width: "100%",
  },
});

const SignInForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const classes = useStyles();

  const signInWithEmailAndPasswordHandler = (
    event?: React.MouseEvent<HTMLButtonElement>
  ) => {
    console.log({ auth });
    if (event) {
      event.preventDefault();
    }
    setIsSubmitting(true);
    auth.signInWithEmailAndPassword(email, password).catch((err) => {
      setError("Error signing in with password and email!");
      console.error("Error signing in with password and email", err);
      setIsSubmitting(false);
    });
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;

    if (name === "userEmail") {
      setEmail(value);
    } else if (name === "userPassword") {
      setPassword(value);
    }
  };

  const onKeyUpHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { code } = event;
    if (code === "Enter") {
      event.currentTarget.querySelector("input")?.blur();
      signInWithEmailAndPasswordHandler();
    }
  };

  return (
    <form>
      <Paper elevation={10} className={classes.paper}>
        <Grid
          container
          direction="column"
          alignItems="center"
          style={{ gap: 15 }}
        >
          <Avatar className={classes.avatar}>
            <img src={Logo} className={classes.logo} alt="Logo" />
          </Avatar>
          <Typography variant="h4">Sign In</Typography>
          <div style={{ minHeight: "2rem" }}>
            {error ? <Typography color="error">{error}</Typography> : null}
          </div>
          <TextField
            required
            name="userEmail"
            label="Email"
            fullWidth
            onChange={onChangeHandler}
            placeholder="user@example.com"
          />
          <TextField
            name="userPassword"
            label="Password"
            fullWidth
            type="password"
            autoComplete="current-password"
            onChange={onChangeHandler}
            onKeyUp={onKeyUpHandler}
            placeholder="*****"
          />

          <ProgressButton
            type="button"
            color="primary"
            variant="contained"
            fullWidth
            size="large"
            disabled={isSubmitting}
            onClick={signInWithEmailAndPasswordHandler}
            inProgress={isSubmitting}
          >
            Log In
          </ProgressButton>
        </Grid>
      </Paper>
    </form>
  );
};
export default SignInForm;
